import { defineStore } from 'pinia'
import { useSessionStorage } from '@vueuse/core'

export type User = {
  firstName: string
  lastName: string
  email: string
  phone: string
  company: string
}

export const useUserStore = defineStore('user', {
  state: () => ({
    user: useSessionStorage<User>('user', {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      company: '',
    }),
  }),
})
